import { Check } from "lucide-react";
import { STEPS } from "./formModel";

/** Barre d'étapes numérotées.
 *  - création : `clickable=false`, on avance via Précédent/Suivant (les étapes
 *    passées sont marquées « faites »).
 *  - édition  : `clickable=true`, on saute librement d'une section à l'autre. */
export function Stepper({
  current,
  onSelect,
  clickable = false,
}: {
  current: number;
  onSelect: (i: number) => void;
  clickable?: boolean;
}) {
  return (
    <nav className="stepper" aria-label="Étapes">
      {STEPS.map((s, i) => {
        const state = i === current ? "current" : i < current ? "done" : "todo";
        return (
          <button
            key={s.id}
            type="button"
            className={`step step-${state}`}
            onClick={() => (clickable || i <= current) && onSelect(i)}
            disabled={!clickable && i > current}
          >
            <span className="step-num">
              {state === "done" ? <Check size={14} /> : i + 1}
            </span>
            <span className="step-title">{s.title}</span>
          </button>
        );
      })}
    </nav>
  );
}
